import React from "react";
import BannerImg from "../assets/images/banner-img.png";
import GrowLogo from "../assets/images/grow-logo.svg";
import useLocale from "../../src/locales/index";
import LanguageSelector from "./LanguageSelector";

const HomeBanner = ({ activeTab }) => {
  const { textData } = useLocale();

  return (
    <div className="">
      <div
        className={`md:min-h-[224px] h-auto  bg-home-banner  bg-no-repeat bg-cover bg-bottom md:pb-0 pb-[40px] relative `}
      >
        {" "}
        <div className=" max-w-[1280px] md:mx-[80px] mx-4 sm:mx-10 lg:mx-[50px] xl:mx-[120px] 2xl:mx-auto">
          <div className="relative z-1 max-sm:pt-3">
            <div className="flex pt-0 relative sm:pt-[28px] justify-start ">
              <div>
                <img
                  src={GrowLogo}
                  alt="Grow-Logo"
                  className="lg:h-[48px] sm:h-[48px] h-[39px]"
                />
              </div>
              <LanguageSelector />
            </div>
            <div className="lg:flex block justify-evenly sm:px-[125px] px-[20px] pb-0">
              <h1 className=" lg:max-w-[300px] m-auto lg:mx-0 sm:max-w-[248px] max-w-[240px] font-lato-bold-700 w-full lg:text-left   text-center lg:text-[24px] sm:text-[20px] text-[18px] text-[#282828] md:leading-[150%]">
                {textData.mainTitle}{" "}
                <span className="bg-gradient-primary bg-clip-text text-[transparent]">
                  {" "}
                  {textData.finance}
                </span>{" "}
                <span className="">
                  {" "}
                  {textData.calculator}
                </span>
              </h1>
              <div className="lg:mt-0">
                <img
                  src={BannerImg}
                  alt="Banner-Img"
                  className="lg:h-[100px] sm:h-[100px]  h-[100px] lg:w-[150px] w-auto m-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default HomeBanner;
